export default __webpack_public_path__ + "static/media/transmon_qubit.ae8c0bca.png";